export default function (url, data = {}, nonce = "", processResults = null) {

    return {
        ajax: {
            url,
            headers: {
                "X-WP-Nonce" : nonce,
            },
            data: (params) => {
                const query = {
                    ...data,
                    page: params.page || 1,
                    search: params.term
                }
            
                return query
            },
            processResults: processResults ?? function (data, params) {
                return {
                    results: data.results,
                    pagination: {
                        more: data.pagination.more
                    }
                };
            },
        },
        language: {
            searching: function () {
                return "Пошук..."
            },
            noResults: function () {
                return "Нічого не знайдено"
            },
            inputTooShort: function () {
                return "Введіть більше символів"
            }
        }
    }
}